import { TeamYear } from "./types";

export const team2022_23: TeamYear = {
  year: "2022-23",
  facultyAdvisors: [{
      id: "fac-1",
      name: "Dr. K.S.Tiwari",
      role: "Faculty Coordinator",
      image: "/team/common/tiwari-mam.jpg",
      deptOrBranch: "E&TC Department",
      social: { linkedin: "https://linkedin.com/in/dr-kanchan-s-tiwari-01705171"},
    },
    {
      id: "fac-2",
      name: "Prof. Yogita Ajgar",
      role: "Faculty Coordinator",
      image: "/team/common/yogita-mam.jpg",
      deptOrBranch: "E&TC Department",
      social: { linkedin: "https://linkedin.com/in/yogita-ajgar-847b1071" },
    },],
  founder: [{
      id: "founder-1",
      name: "Arnav Botre",
      role: "Founder",
      image: "/team/common/arnav.jpg",
      deptOrBranch: "Alumni - E&TC",
      social: { linkedin: "https://www.linkedin.com/in/arnav-botre-b2a7591b2/", instagram:"https://www.instagram.com/arnav_botre14/", email: "botrearnav@gmail.com" },
    },],
  coreCommittee: [
    {
      id: "core-1",
      name: "Aditya Khapake",
      role: "President",
      image: "/team/2022-23/aditya.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/aditya-khapake-0b49ba213", instagram: "https://instagram.com/aditya_khapake?igshid=YmMyMTA2M2Y=", email:"adik.info17@gmail.com"},
    },
    {
      id: "core-2",
      name: "Hemant Mankar",
      role: "Vice President",
      image: "/team/2022-23/hemant.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/hemant-mankar-3204a7225", instagram: "http://instagram.com/hemant_._26", email:"hemantmankar007@gmail.com"},
    },
   {
      id: "core-3",
      name: "Neeraj Chhajed",
      role: "Documentation Head",
      image: "/team/2022-23/neeraj.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/neeraj-chhajed-437741209", instagram: "https://instagram.com/neeraj.chhajed?igshid=YmMyMTA2M2Y=", email:"neerajchhajed601@gmail.com"},
    },
    {
      id: "core-4",
      name: "Mitali Pardeshi",
      role: "Treasurer",
      image: "/team/2022-23/mitali.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/mitali-pardeshi-b76210219", instagram: "https://instagram.com/mitalipardeshi___?igshid=YmMyMTA2M2Y=", email:"pardeshimitali757@gmail.com"},
    },
    {
      id: "core-5",
      name: "Shubh Malkar",
      role: "Publicity Head",
      image: "/team/2022-23/shubh.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/shubh-malkar-b8a4351a0", instagram: "https://instagram.com/shubh.malkar__?igshid=YmMyMTA2M2Y=", email:"shubhmalkar@gmail.com"},
    },
    {
      id: "core-6",
      name: "Anjali Pardeshi",
      role: "Publicity Head",
      image: "/team/2022-23/anjali.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/anjali-pardeshi-05209b1a5", instagram: "https://instagram.com/sherni_punjab_di?igshid=YmMyMTA2M2Y=", email:"anjalipardeshi60@gmail.com"},
    },
    {
      id: "core-7",
      name: "Atharva Mungase",
      role: "Event Co-ordinator",
      image: "/team/2022-23/atharva.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/prasad-nikam-6176a1231", instagram: "https://www.instagram.com/_prasad_nikam/", email:"prasadnikam2003@gmail.com"},
    },
    {
      id: "core-8",
      name: "Prasad Nikam",
      role: "Event Co-ordinator",
      image: "/team/2022-23/prasad.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/prasad-nikam-6176a1231", instagram: "https://instagram.com/_prasad_nikam?igshid=YmMyMTA2M2Y=", email:"prasadnikam2003@gmail.com"},
    },
    {
      id: "core-9",
      name: "Shivam Kudal",
      role: "Social Media Head",
      image: "/team/2022-23/shivam.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/shivam-kudal-8a0b65179", instagram: "https://instagram.com/_magical_mutes_02?igshid=YmMyMTA2M2Y=", email:"shivam6402@gmail.com"},
    },
    {
      id: "core-10",
      name: "Akshada Phadatare",
      role: "Social Media Head",
      image: "/team/2022-23/akshada.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/akshada-phadatare-422630231",instagram: "https://www.instagram.com/1608_akshada_phadatare/", email: "akshadaphadatare49@gmail.com" },
    },
    {
      id: "core-11",
      name: "Kedarnath Tawde",
      role: "Marketing Head",
      image: "/team/2022-23/kedarnath.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/kedar-tawde-527839231",instagram :"https://www.instagram.com/kedar._tawde/",  email:"tawdekedar@gmail.com"},
    },
    {
      id: "core-12",
      name: "Sakhib Shaikh",
      role: "Marketing Head",
      image: "/team/2022-23/sakhib.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/sakhib-shaikh-a6438a213/ ", instagram: "https://instagram.com/myself_sss_786?igshid=YmMyMTA2M2Y=", email:"sakhibshaikh786@gmail.com"},
    },
    {
      id: "core-13",
      name: "Shravani Kadam",
      role: "Student Co-ordinator",
      image: "/team/2022-23/shravani.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/shravani-kadam-47a4b0213", instagram: "https://instagram.com/shravani5808?igshid=YmMyMTA2M2Y=", email:"shravanikadam1576@gmail.com"},
    },
    {
      id: "core-14",
      name: "Vaishnavi Mandlik",
      role: "Student Co-ordinator",
      image: "/team/2022-23/vaishnavi.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/vaishnavi-mandlik-001931231", instagram: "https://instagram.com/_xviii_vaishnavi?igshid=YmMyMTA2M2Y=", email:"mvaishnavi924@gmail.com"},
    },
    {
      id: "core-15",
      name: "Nirbhay Khande",
      role: "Student Co-ordinator",
      image: "/team/2022-23/nirbhay.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/nirbhay-khande-91984a231", instagram: "https://www.instagram.com/_me_nirbhay_/", email: "nckhande7551@gmail.com" },
    },
  ],
};

export {}; // ✅ This ensures it is treated as a module
